
<cvt-settings
  :active-tab="settingsActiveTab"
  :usage="'PopupSiteSettings'"
  @toggle="(id) => setSettingsActiveTab(id)"
>
  <template #general>
    <div class="nav-tab-wrap">
      <!-- Popup Name Input -->
      <div class="row pb-3 mb-4">
        <div class="col-md-10">
          <cvt-input
            type="text"
            name="name"
            :floating-label="false"
            :label="'Popup Name'"
            :clearable="false"
            value="Test Popup"
          />
        </div>
      </div>

      <!-- Brand Colors -->
      <div class="row mb-4">
        <p class="col-md-10">Select Brand Colors</p>
        <div class="col-md-10">
          <colors
            :alpha="false"
            :mode="mode"
            usage="SapSiteSettings"
          ></colors>
        </div>
      </div>

      <!-- Font Family, Font Size & Font Default Text Color -->
      <cvt-collapse class="row" :accordion="true" :prepend-chevron="true">
        <cvt-collapse-item
          :title="'Typography'"
          name="properties"
          :initial-active="true"
        >
          <div
            v-for="style in fontStyles"
            :key="style.label"
            class="row flex-grow-1 mb-3"
          >
            <div
              class="col-md-3 d-flex justify-content-end align-items-center mt-3 mb-1"
            >
              <p
                class="my-auto"
                :style="style.format.toStyle()"
                v-text="$t(`setup.font.${snakeCase(style.label)}`)"
              />
            </div>
            <div
              class="col-md-7 d-flex justify-content-center align-items-center"
            >
              <div class="row flex-grow-1">
                <div class="col-7">
                  <font-selector
                    :value="style.format.font"
                    @input="updateFontFamily(style, $event)"
                  />
                </div>
                <div class="col-5">
                  <font-size-selector
                    :value="style.format.size"
                    @input="updateFontSize(style, $event)"
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-2 d-flex justify-content-center align-items-center mt-3 mb-1"
            >
              <div class="row">
                <div class="col-12">
                  <default-color-selector
                    :value="style.format.defaultTextColor"
                    @input="updateDefaultTextColor(style, $event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </cvt-collapse-item>
      </cvt-collapse>

      <!-- Button Default Styles -->
      <cvt-collapse class="row" :accordion="true" :prepend-chevron="true">
        <cvt-collapse-item
          :title="'Buttons'"
          name="properties"
          :initial-active="false"
        >
          <div
            v-for="style in buttonDefaultStyles"
            :key="style.label"
            class="row flex-grow-1"
          >
            <div
              class="col-md-3 d-flex justify-content-end align-items-center mt-3 mb-1"
            >
              <div class="c-btn-wrapper">
                <c-button class="my-auto" :cta="style.label" />
              </div>
            </div>
            <div
              class="col-md-7 d-flex justify-content-center align-items-center"
            >
              <div class="row flex-grow-1">
                <div class="col-7">
                  <font-selector
                    :value="style.format.fontFamily"
                    @input="updateButtonDefaultFontFamily(style, $event)"
                  />
                </div>
                <div class="col-5">
                  <font-size-selector
                    :value="style.format.fontSize"
                    @input="updateButtonDefaultFontSize(style, $event)"
                  />
                </div>
              </div>
            </div>
            <div
              class="col-md-2 d-flex justify-content-center align-items-center mt-3 mb-1"
            >
              <div class="row">
                <div class="col-12">
                  <default-color-selector
                    :value="style.format.defaultBackgroundColor"
                    @input="updateButtonDefaultBackgroundColor(style, $event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </cvt-collapse-item>
      </cvt-collapse>

      <!-- Link Default Styles -->
      <cvt-collapse class="row" :accordion="true" :prepend-chevron="true">
        <cvt-collapse-item
          :title="'Links'"
          name="properties"
          :initial-active="false"
        >
          <div
            v-for="style in linkDefaultStyles"
            :key="style.label"
            class="row flex-grow-1"
          >
            <div
              class="col-md-3 d-flex justify-content-end align-items-center mt-1 mb-2"
            >
              <div class="c-btn-wrapper">
                <a
                  class="my-auto underline-link"
                  :style="style.format.getLinkFontStyle()"
                >
                  {{ style.label }}
                </a>
              </div>
            </div>
            <div class="col-md-2 d-flex align-items-center m-0">
              <div class="row">
                <div class="col-12">
                  <default-color-selector
                    :value="style.format.defaultTextColor"
                    @input="updateFroalaLinkDefaultTextColor(style, $event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </cvt-collapse-item>
      </cvt-collapse>
    </div>
  </template>

  <template #audience>
    <div class="nav-tab-wrap">
      <cvt-sap-audience />
    </div>
  </template>

  <template #rules>
    <div class="nav-tab-wrap">
      <cvt-sap-rules />
    </div>
  </template>

</cvt-settings>
